<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import BankingRulesWorkspace from '@/views/Banking/Rules/BankingRulesWorkspace.vue'

setPageTitle(PageMeta.Banking.Rules.Title)
definePage({ meta: PageMeta.Banking.Rules.Meta })
</script>

<template>
  <BankingRulesWorkspace />
</template>
